import type { ReactNode } from 'react'

const id = 'main-content'

export function Main({ children }: { children: ReactNode }) {
  return (
    <main className='grid-in-content h-full gap-2' id={id}>
      {children}
    </main>
  )
}

export function IndexRoot({ children }: { children: ReactNode }) {
  return (
    <main className='relative px-6 pt-8 pb-16' id={id}>
      {/* Wrap with a width */}
      <div className='mx-auto max-w-7xl'>{children}</div>
    </main>
  )
}
